import styled from 'styled-components';

export const StyledShowreel = styled.div` 
position: relative;
background: black;
margin-top: 50px;
i {
    cursor: pointer;
    display: inline-block;
    font-size: 40px;
    
    &.fas.fa-volume-mute {
    color: white;
    }
    
    &.fas.fa-volume-up {
    color: #ffdb2a;
    }
}

`;

export const StyledTitleContainer = styled.div`
    display: flex;
    position: absolute;
    z-index: 1;
    left: 50%;
    transform: translateX(-50%);
    justify-content: space-between;
    align-items: center;
    width: 400px;
`;

export const StyledShowReelTitle = styled.span`
  display: block;
  font-size: 40px;
  z-index: 2;
  color: wheat;
  letter-spacing: 7px;
`;

export const StyledReactPlayerWrapper = styled.div`
z-index: 1;
position: relative;
padding-top: 56.25%; /* Player ratio: 100 / (1280 / 720) */
.react-player {
  position: absolute;
  top: 0;
  left: 0;
}
`;
